var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "is-in-wechat", on: { click: _vm.closeWechatTip } },
    [
      _c("div", { staticClass: "ns-arrow-icon" }),
      _vm._v(" "),
      _c("p", [_vm._v(_vm._s(_vm.getConstants("OPEN_IN_BROWSER_TIP_1")))]),
      _vm._v(" "),
      _c("p", [_vm._v(_vm._s(_vm.getConstants("OPEN_IN_BROWSER_TIP_2")))])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }